import React, { useEffect, useState } from 'react';
import yCheck from "../../assets/img/templates/y-check.png";
import { Button } from "reactstrap";
import { doc, getDoc } from "firebase/firestore";
import { getDb, packageLinks } from "../../util/Constants";

const PlanCard = ({ name, price, features, signedInUser, product_id }) => {

    const [priceIds, setPriceIds] = useState({ standard: "", premium: "" });

    useEffect(() => {
        loadPriceIds().then(results => {
            console.log(results);
            setPriceIds({ ...results });
        })
    }, []);

    const loadPriceIds = async () => {
        const standardRef = doc(getDb(), "plans", "standard");
        const premiumRef = doc(getDb(), "plans", "premium");
        const standardSnap = await getDoc(standardRef);
        const premiumSnap = await getDoc(premiumRef);
        return {
            standard: standardSnap.data().price_id,
            premium: premiumSnap.data().price_id
        };
    }

    // const makePayment = async (name) => {
    //     if (name === "Standard") {
    //         window.location.href = packageLinks.standard + "?prefilled_email=" + signedInUser.email;
    //     }
    //     else if (name === 'Premium') {
    //         window.location.href = packageLinks.premium + "?prefilled_email=" + signedInUser.email;
    //     }
    // }


    const makePayment = (productId, customerId) => {

        const currentDomain = window.location.origin;
        let url;
        // if (environment === "live") {
        //     url = `https://secure.2checkout.com/order/checkout.php?PRODS=${productId}&QTY=1&CUSTOMERID=${customerId}&BACK_REF=${currentDomain}`;
        // } else {

        url = `https://secure.2checkout.com/order/checkout.php?PRODS=${productId}&QTY=1&DOTEST=1&CUSTOMERID=${customerId}&BACK_REF=${currentDomain}`;

        // }


        window.location.href = url;
    };



    return (
        <div className="col-md-6 col-lg-5 col-xl-4 col-sm-12 hvr-buzz-out mb-3 mb-sm-0">
            <div className="card card1 mx-auto mb-3">
                <div className="card-header card-header1 py-4">
                    {name} <br />
                    {price ? `$${price}` : 'Contact'}
                </div>
                <div className="card-body custom-card my-3 my-xl-3 my-lg-0">
                    {features.map((feature, index) => (
                        <div className="row px-0 px-md-5" key={index}>
                            <div className="col-1">
                                <img className="" src={yCheck} alt="" />
                            </div>
                            <div className="col-10">
                                <p className="sub-title text-nowrap">{signedInUser.projectType === "progress" ? feature.replace(/assessment/gi, 'Learning') : feature}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="text-center">
                    {signedInUser.plan.toLowerCase() === name.toLowerCase() &&
                        <span className="active-text">
                            (Current)
                        </span>
                    }
                </div>
                <div className="mb-5 text-center">
                    {name === "Business" ?
                        <a href="mailto:hello@activ8games.com?subject=ACE - Business Contact Request">
                            <Button color="" className="hvr-glow1 hvr-change1 wow animate__fadeInDown"
                                data-wow-delay="1s">
                                Contact Support
                            </Button>
                        </a> :
                        <Button color=""
                            onClick={() => {

                                const {
                                    email
                                } = signedInUser

                                makePayment(product_id, email)

                            }}

                            className="hvr-glow1 hvr-change1 wow animate__fadeInDown"
                            data-wow-delay="1s"
                            id={`${name.toLowerCase()}-plan`}
                        >
                            Upgrade
                        </Button>
                    }
                </div>
            </div>
        </div>
    );
};

export default PlanCard;